import { Component, OnInit } from '@angular/core';
import { Evento } from '../../../model/evento';
import { EventosService } from './eventos.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NotificationService } from '../../../notification/notification.service';

@Component({
  selector: 'app-eventos',
  templateUrl: './eventos.component.html',
  styleUrls: ['./eventos.component.css']
})
export class EventosComponent implements OnInit {

  private novoEvento: Evento;
  private usuario_logado: any = JSON.parse(sessionStorage.getItem("usuario"));
 
  evento: Evento;
  listaEventos;
  eventoForm: NgForm;

  constructor(private eventosService: EventosService, private router: Router,
    private notificationService: NotificationService) {
    this.evento = new Evento();
    this.evento.description = ' ';

    this.getEventos();
  }

  ngOnInit() {  }

  onSubmit() {
    this.eventosService.cadastrarEvento(this.evento)
    .subscribe(
      res => {
        this.getEventos(); 
        this.notificationService.info(
          "Evento cadastrado com sucesso!"
        ); 
      },
        error => {
          this.notificationService.error(
            "Opa! Verifique se preencheu os campos corretamente e tente novamente."
          );     
        }
      
    );
    var inputValue = document.getElementById('titulo') as HTMLInputElement;
    inputValue.value = "";
 }

  getEventos() {
    this.eventosService.listarEventos()
      .subscribe(
        data => {
          this.listaEventos = data;
        }
      )
  }

  deletarEvento(id) {
    this.eventosService.deletarEvento(id)
      .subscribe(res => {
        this.novoEvento = res;
        this.getEventos(); 
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/gerenciador/dashboard/eventos/eventos.component.ts